import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { XCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PaymentCancelled = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-background via-primary/5 to-background">
      <Navigation />

      <section className="pt-32 pb-20 px-4">
        <div className="max-w-3xl mx-auto">
          <Card className="p-12 shadow-2xl text-center space-y-8">
            <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-muted mx-auto">
              <XCircle className="w-12 h-12 text-muted-foreground" />
            </div>

            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl font-bold">Payment Cancelled</h1>
              <p className="text-xl text-muted-foreground">
                Your payment was not completed
              </p>
            </div>

            <div className="bg-muted/50 rounded-lg p-6">
              <p className="text-muted-foreground">
                No charges were made to your account. If you experienced any issues or have questions, 
                please don't hesitate to contact our support team.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
              <Button 
                size="lg"
                onClick={() => navigate("/pricing")}
                className="bg-gradient-to-r from-primary to-accent hover:opacity-90"
              >
                Try Again
              </Button>
              <Button 
                size="lg"
                variant="outline"
                onClick={() => navigate("/")}
              >
                Return to Home
              </Button>
            </div>
          </Card>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PaymentCancelled;
